/**
 * 一些响应客户端事件的响应
 */
import { createListener } from '../common/utils';
export var WebviewNameSpace = 'Frodo.Webview';
export function listenMessageFromClient(name, cb) {
    return createListener(WebviewNameSpace, name, cb);
}
//# sourceMappingURL=listener.js.map